// Test IDs used across the landing page.
export const TID = {
  // Nav
  navRoot: "navigation-root",
  navMethod: "nav-link-method",
  navAuthor: "nav-link-author",
  navReviews: "nav-link-reviews",
  navFaq: "nav-link-faq",
  navCta: "nav-purchase-btn",

  // Hero
  heroSection: "hero-section",
  heroCta: "hero-cta-btn",
  heroSecondary: "hero-secondary-btn",

  // Pillars
  pillarsSection: "pillars-section",

  // Author
  authorSection: "author-bio-section",

  // TOC
  tocSection: "toc-section",

  // Testimonials
  testimonialsSection: "testimonials-section",

  // Pricing
  pricingSection: "pricing-section",
  pricingStripeBtn: "pricing-stripe-btn",
  pricingExternalBtn: "pricing-external-btn",

  // Newsletter
  newsletterSection: "newsletter-section",
  newsletterEmail: "newsletter-email-input",
  newsletterSubmit: "newsletter-submit-btn",

  // FAQ
  faqSection: "faq-section",
  faqItem: "faq-accordion-item",

  // Footer
  footer: "footer-root",
};
